var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-wrapper"},[(_vm.isLogged && !_vm.$store.state.sidebar.locked)?_c('navbar',{attrs:{"notifications":_vm.notifications,"reports":_vm.reports,"loadingNotifications":_vm.loadingNotifications,"loadingReports":_vm.loadingReports,"pTitle":_vm.pageTitle},on:{"signoff":_vm.logout}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }